import { useRef } from 'react';
import { DateTimeBox } from '@apply/components';
import { DateTimeBoxLabelSize } from '@apply/components/src/components/controls/DateBox/DateTimeBox';
import { useExperienceDateSold } from '../../../../../../fields/ExperienceFields';

interface ExactDateSoldProps {
    experienceId: string | undefined;
    required?: boolean;
    readOnly?: boolean;
}

export const ExactDateSold: React.FC<ExactDateSoldProps> = ({ experienceId, required = false, readOnly = false }) => {
    const isFirstLoad = useRef(true);
    const [dateSold, set_dateSold] = useExperienceDateSold(experienceId);

    // Normalize incoming value
    const normalizedDate = typeof dateSold === 'string' ? new Date(dateSold + 'T00:00:00') : (dateSold ?? undefined);

    const handleChange = (value: any) => {
        // Skip the first change triggered by initial load
        if (isFirstLoad.current) {
            isFirstLoad.current = false;

            if (dateSold !== undefined && dateSold !== null) {
                return;
            }
        }

        // Normalize outgoing value
        if (typeof value === 'string') {
            set_dateSold(new Date(value));
        } else {
            set_dateSold(value);
        }
    };

    return (
        <>
            <>
                <DateTimeBox
                    id='experienceDateSold'
                    required={required}
                    value={normalizedDate}
                    onChange={handleChange}
                    label={''}
                    labelSize={DateTimeBoxLabelSize.Small}
                    readOnly={readOnly}
                    width='220px'
                />
            </>
        </>
    );
};
